/**
 * Buyer UserModel primary key (`user.id` / `UserModel.id`) for interior-designer APIs
 * when the caller is not that buyer (e.g. BV_USER, sales).
 *
 * Not: login row id, customer_sales id, interior designer id.
 */
export function resolveBuyerUserId(buyerIdProp, saleDataUser) {
  if (buyerIdProp != null && buyerIdProp !== "") {
    return buyerIdProp;
  }
  const u = saleDataUser || {};
  return u.userId ?? u.user_id ?? u.id ?? null;
}
